import React from "react";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect, useState } from "react";
import '../css/Home.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import book1 from "../pics/Book1-Front.png"
import book2 from "../pics/Book2-Front.jpg"
import ylys from "../pics/ylys.png"
import icon1 from "../pics/Aicon1.png"
import icon2 from "../pics/Gicon3.png"
import icon3 from "../pics/Bicon2.png"
import icon4 from "../pics/Ficon4.png"
import yellowcicle from "../pics/yellowcircle.png"
import whoarewe from "../pics/whoarewe.jpeg"
import alwiLogo from "../logos/Alwi-logo.png"
import copLogo from "../logos/Cop-logo.jpeg"
import kazLogo from "../logos/Kaz-logo.png"
import nzLogo from "../logos/NZ-logo.png"
import riseLogo from "../logos/Rise-logo.png"
import techvellyLogo from "../logos/Techvelly-logo.jpeg"
import Spline from '@splinetool/react-spline';
import emailjs from "@emailjs/browser";
import toast from "react-hot-toast";
import { X, Mail } from "lucide-react";

const SERVICE_ID  = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

export default function Home() {
  const navigate = useNavigate();
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [subscribeForm, setSubscribeForm] = useState({ firstName: "", email: "" });
  const [subscribing, setSubscribing] = useState(false);

  const handleSubscribeChange = (e) =>
    setSubscribeForm({ ...subscribeForm, [e.target.name]: e.target.value });

  const handleSubscribeSubmit = async (e) => {
    e.preventDefault();
    setSubscribing(true);
    try {
      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          form_type: "Mailing List Subscription",
          name: subscribeForm.firstName,
          email: subscribeForm.email,
          phone: "—",
          position: "—",
          message: `${subscribeForm.firstName} subscribed to the mailing list.`,
          time: new Date().toLocaleString(),
        },
        PUBLIC_KEY
      );
      toast.success("Subscribed! Thanks for joining our mailing list.");
      setSubscribeForm({ firstName: "", email: "" });
      setShowSubscribeModal(false);
    } catch (err) {
      console.error("Subscribe error:", err);
      toast.error(err?.text || err?.message || "Failed to subscribe. Please try again.");
    } finally {
      setSubscribing(false);
    }
  };

  const books = [
    {
      img: book1,
      title: "GUIDING LIGHTS FROM THE GATE OF KNOWLEDGE",
      subtitle: "VOLUME-1",
    },
    {
      img: book2,
      title:  "GUIDING LIGHTS FROM THE GATE OF KNOWLEDGE",
      subtitle: "VOLUME-2",
    }
  ];
const items = [
  { icon: icon1, title: "Academic" },
  { icon: icon2, title: "Businesses & Companies" },
  { icon: icon3, title: "Online Educational Platforms" },
  { icon:  icon4, title: "Families & Individuals" },
];
  const controls = useAnimation();
  const textControls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.3 });
 const [inView2, setInView] = useState(false);
  useEffect(() => {
  const handleScroll = () => {
    const section = document.getElementById("stay-connected");
    if (section) {
      const rect = section.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight * 0.8 && rect.bottom >= 0;
      if (isVisible) setInView(true);
      else setInView(false);
    }
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

useEffect(() => {
  if (inView) {
    // 🔹 Trigger animation when in view
    textControls.start({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    });
    controls.start({
      opacity: 1,
      x: 0,
      y: 0,
      transition: { duration: 1, ease: "easeOut" },
    });
  } else {
    // 🔹 Reset when out of view
    textControls.start({ opacity: 0, y: 30 });
    controls.start({ opacity: 0, x: 200, y: -200 });
  }
}, [inView, textControls, controls]);


  return (
    <div>
     {/* Hero Section */}
<section className="relative flex bg-black flex-col md:flex-row items-center justify-between px-16 py-24 overflow-hidden">

  {/* 🔹 Background Spline Animation */}
  <div className="absolute inset-0 z-0">
    <Spline scene="https://prod.spline.design/j5zobmBEiVzLPVLu/scene.splinecode" />
  </div>

  {/* LEFT SIDE — Text Content */}
  <div className="z-10 max-w-lg text-center md:text-left">
    <h4 className="text-5xl font-modum font-bold text-white leading-none tracking-wide">
      PRACTICAL GUIDANCE <br /> FOR EVERY STAGE,
    </h4>

    <p className="mt-4 text-xl uppercase font-modum bg-white border-2 border-black inline-block px-4 py-1 tracking-wider">
      Timeless Wisdom for Modern Challenges
    </p>

    <p className="mt-4 text-white text-lg leading-relaxed text-justify">
      Helping you live a balanced, fulfilling life in harmony with the
      teachings of respected Islamic scholars and educators.
    </p>
  </div>

</section>

  {/* WHO ARE WE SECTION */}
<section
  ref={ref}
  className="px-16 py-16 bg-white relative flex flex-col md:flex-row items-center justify-between overflow-hidden"
>
  {/* Left Section (Text) */}
  <motion.div
    className="max-w-3xl md:w-1/2 z-10"
    initial={{ opacity: 0, y: 30 }}
    animate={textControls}
    transition={{ duration: 0.8, ease: "easeOut" }}
  >
    <h3 className="text-5xl font-modum font-bold mb-4 tracking-wide">
      WHO ARE WE
    </h3>
    <p className="text-gray-600 leading-relaxed text-justify max-w-screen-sm tracking-wide">
      Alnoor Edtech helps you to live a balanced, fulfilling life in
      harmony with the teachings of respected Islamic scholars and
      educators without overwhelming your learning. From making choices
      with strong values, to nurturing a life in harmony, to enhancing
      crucial life skills, our courses, guide books, and resources bring
      wisdom into your everyday life.
    </p>

    <Button onClick={() => navigate("/about")} className="mt-6 bg-brand text-black rounded-xl hover:bg-black hover:text-brand active:bg-black active:text-brand transition-all duration-300">
      Read More
    </Button>
  </motion.div>

  {/* Center Image */}
  <motion.div
    className="md:w-42 relative flex justify-center items-center z-20 -ml-5 mt-10 md:mt-0"
    initial={{ opacity: 0, scale: 0.9, y: 30 }}
    animate={textControls}
    transition={{ duration: 0.9, ease: "easeOut" }}
  >
    <motion.img
      src={whoarewe}
      alt="Who are We"
      className="w-68  h-60 rounded-lg object-cover shadow-lg ml-4"
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 120 }}
    />
  </motion.div>

  {/* Animated Yellow Circle */}
  <motion.div
    className="hidden md:block w-72 h-72 bg-brand rounded-full absolute opacity-90 blur-sm"
    initial={{ x: 500, y: -200, opacity: 0, scale: 0.8 }}
    animate={{
      x: 0,
      y: 0,
      opacity: 1,
      scale: [1, 1.05, 1],
      transition: {
        duration: 2,
        ease: "easeOut",
        repeat: Infinity,
        repeatType: "reverse",
      },
    }}
    style={{ right: "10%", top: "20%" }}
  />
</section>


  <section className="relative px-8 md:px-16 py-16 bg-brand text-center md:text-left overflow-hidden">
      {/* Heading */}
      <motion.h3
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
        className="text-5xl font-bold font-modum mb-8 tracking-wide"
      >
        YOUR LIFE, YOUR STAGE
      </motion.h3>

      {/* Paragraph */}
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
        viewport={{ once: true }}
        className="-mt-4 mb-12 text-gray-800 max-w-xl"
      >
        Alnoor Edtech helps you to live a balanced, fulfilling life in harmony.
      </motion.p>

      {/* Image */}
      <motion.img
        src={ylys}
        alt="Your Life, Your Stage"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
        viewport={{ once: false }}
        className="mx-auto rounded-3xl shadow-lg"
      />
    </section>

<div
  className="h-[22vh] relative"
  style={{
    background: "linear-gradient(to bottom, #ffda1a 50%, #ffffff 50% 100%)"
  }}
>
  <div className="relative max-w-6xl w-full px-8 md:px-16 py-8  rounded-[40px] border-2 border-black shadow-md
 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white ">
    <h3 className="text-5xl  font-modum font-bold mb-4 tracking-wide text-center">
      WHY WE’RE UNIQUE
    </h3>
    <p className="text-gray-700 max-w-8xl leading-relaxed text-xl md:text-2xl text-center">
      Most platforms only focus on academics or one specific mode of life.
      Our strength lies in blending values, knowledge, and modern tools
      to guide you meaningfully at every stage.
    </p>
  </div>
</div>

  <motion.section
      className="px-8 md:px-16 py-16 bg-[#faf7f2] flex flex-col md:flex-row items-center gap-10 overflow-hidden"
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.3 }}
    >
      {/* ================= LEFT CONTENT ================= */}
      <motion.div
        className="flex-1"
        initial={{ x: -80, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <h3 className="text-3xl md:text-5xl font-modum font-bold mb-4 tracking-wide">
        PLATFORM OPEN FOR ALL
        </h3>

        <p className="text-gray-700 text-justify mb-6 leading-relaxed max-w-md">
          AlNoor Edtech is built on inclusivity. While our foundation is inspired
          by Islamic teachings, our lessons carry values that resonate with people
          of every faith and background. This makes us not just a platform, but a
          bridge where diverse people come together to learn, grow, and share.
        </p>

        <Button onClick={() => navigate("/books")} className="mt-6 bg-brand text-black  rounded-xl hover:bg-black hover:text-brand active:bg-black active:text-brand">
          Buy Now
        </Button>
      </motion.div>

      {/* ================= RIGHT CONTENT (Swiper Carousel) ================= */}
      <motion.div
        className="flex-1 w-full min-w-0"
        initial={{ x: 80, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <motion.div
          className="rounded-lg"
        >
          <Swiper
            modules={[Navigation, Pagination]}
            navigation
            pagination={{ clickable: true }}
            spaceBetween={20}
            slidesPerView={1}
            breakpoints={{
              768: { slidesPerView: 2 },
            }}
            style={{
              "--swiper-navigation-color": "#000",
              "--swiper-pagination-color": "#000",
            }}
            className="rounded-lg pb-10"
          >
            {books.map((book, idx) => (
              <SwiperSlide key={idx}>
                <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center">
                  <div className="relative w-full h-[320px] bg-[#faf7f2] rounded-lg flex items-center justify-center mb-4">
                    <motion.img
                      src={book.img}
                      alt={book.title}
                      className="max-h-full max-w-full object-contain rounded-lg"
                      whileHover={{ scale: 1.03 }}
                      transition={{ duration: 0.3 }}
                    />
                  </div>
                  <h4 className="font-poppins font-bold text-base mb-2 tracking-wide">
                    {book.title}
                  </h4>
                  <p className="inline-block bg-black text-brand text-sm font-medium px-3 py-1 rounded-full">
                    {book.subtitle}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </motion.div>
    </motion.section>
<section className="bg-black text-white  px-14 scroll py-20 -pb-6 overflow-hidden">
  <div className="flex flex-col md:flex-row items-center justify-between ">
    
    {/* LEFT TEXT SECTION */}
    <div className="max-w-md text-left flex flex-col justify-between ">
      <div>
        <h3 className="text-white font-modum text-5xl tracking-wide leading-none mb-6">
          ALNOOR EDTECH IS <br /> OPEN FOR SUPPORT
        </h3>

        <h3 className="border border-white py-2 mb-6 w-fit px-4 text-xl font-modum">
          VOLUNTEERS, PARTNERSHIPS AND COLLABORATIONS
        </h3>
      </div>
    </div>

    {/* RIGHT ICON GRID */}
  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-8 justify-items-center">
  {items.map((item, idx) => (
    <motion.div
      key={idx}
      className="relative w-36 h-36 flex items-center justify-center cursor-pointer"
      initial={{ x: -150, opacity: 0 }}
      whileInView={{ x: 0, opacity: 1 }}
      whileHover={{
        scale: 1.05,
      }}
      transition={{
        duration: 0.8,
        delay: idx * 0.2,
        ease: "easeOut",
      }}
      viewport={{ once: false, amount: 0.3 }}
    >
      {/* Yellow Circle Background */}
      <motion.img
        src={yellowcicle}
        alt="yellow circle"
        className="absolute w-full h-full object-contain"
        whileHover={{
          rotate: 20,
          scale: 1.05,
          transition: { type: "spring", stiffness: 120 },
        }}
      />

      {/* White Circle */}
      <motion.div
        className="relative w-28 h-28 bg-white rounded-full shadow-md flex flex-col items-center justify-center text-black"
        whileHover={{
          scale: 1.08,
          transition: { duration: 0.3 },
        }}
      >
        <motion.img
          src={item.icon}
          alt={item.title}
          className="w-7 h-7 object-contain"
          whileHover={{ scale: 1.2 }}
        />
        <p className="mt-2 text-[11px] font-semibold text-center">
          {item.title}
        </p>
      </motion.div>
    </motion.div>
  ))}
</div>


</div>
</section>
<section className="bg-white text-black px-14 py-20 overflow-hidden">
  <h3 className="text-black font-modum font-bold text-5xl tracking-wide leading-none mb-12 text-center">
    OUR COLLABORATIONS
  </h3>
  <div className="flex flex-wrap items-center justify-center gap-20 md:gap-20 max-w-8xl mx-auto">
    {[
      { src: alwiLogo, size: "h-20 md:h-24" },
      { src: copLogo, size: "h-20 md:h-24" },
      { src: kazLogo, size: "h-20 md:h-24" },
      { src: nzLogo, size: "h-20 md:h-36" },
      { src: riseLogo, size: "h-26 md:h-28" },
      { src: techvellyLogo, size: "h-34 md:h-48" },
    ].map((logo, idx) => (
      <motion.img
        key={idx}
        src={logo.src}
        alt={`collaboration logo ${idx + 1}`}
        className={`${logo.size} w-auto object-contain hover:grayscale-0 transition-all duration-300`}
        whileHover={{ scale: 1.08 }}
        transition={{ type: "spring", stiffness: 200 }}
      />
    ))}
  </div>
</section>

<section id="stay-connected">
      <div className="relative bg-brand overflow-hidden">
        {/* Yellow Top Section */}
        <div className="h-48 bg-brand"></div>

        {/* White + Black Curve */}
        <div className="relative">
          <svg
            className="absolute top-[-1px] left-0 w-full"
            viewBox="0 0 1440 320"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Black Line (base) */}
            <path
              d="M0,96L60,117.3C120,139,240,181,360,197.3C480,213,600,203,720,176C840,149,960,107,1080,117.3C1200,128,1320,192,1380,224L1440,256"
              stroke="black"
              strokeWidth="6"
              fill="none"
              strokeLinecap="round"
            />

            {/* Animated White Glow */}
            <motion.path
              d="M0,96L60,117.3C120,139,240,181,360,197.3C480,213,600,203,720,176C840,149,960,107,1080,117.3C1200,128,1320,192,1380,224L1440,256"
              stroke="white"
              strokeWidth="6"
              fill="none"
              strokeLinecap="round"
              strokeDasharray="200 1000"
              strokeDashoffset="1000"
              animate={
                inView2
                  ? {
                      strokeDashoffset: [1000, -1000],
                      opacity: [0.2, 1, 0.2],
                      transition: {
                        duration: 4,
                        ease: "linear",
                        repeat: Infinity,
                      },
                    }
                  : {}
              }
            />
          </svg>
        </div>

        {/* Main Content */}
        <div className="relative max-w-6xl mx-auto px-4 pb-16 -mt-32">
          <h3 className="text-2xl tracking-wide md:text-5xl font-modum font-bold mb-12 text-center">
            STAY CONNECTED, KEEP GROWING
          </h3>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 place-items-center justify-items-center max-w-3xl mx-auto">
            {/* Left Circle */}
            <div className="relative">
              <div className="w-60 h-60 bg-white rounded-full shadow-lg flex items-center justify-center p-8 text-center">
                <p className="text-sm">
                  <b>Subscribe</b>
                  <br /> to receive weekly tips, free guides, and updates on new
                  courses—delivered straight to your inbox
                </p>
              </div>

              <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-6">
                <button onClick={() => setShowSubscribeModal(true)} className="bg-brand text-black hover:bg-black hover:text-brand rounded-xl transition-all duration-300 px-6 py-2 font-bold shadow-md">
                  SUBSCRIBE
                </button>
              </div>
            </div>

            {/* Right Circle */}
            <div className="relative">
              <div className="w-60 h-60 bg-white rounded-full shadow-lg flex items-center justify-center p-8 text-center">
                <p className="text-sm">
                  <b>Sign up for newsletter</b>
                  <br /> is a small dose of wisdom, encouragement, and practical
                  advice designed to brighten your everyday routine
                </p>
              </div>

              <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-6">
                <button onClick={() => navigate("/register")} className="bg-brand text-black hover:bg-black hover:text-brand rounded-xl transition-all duration-300 px-6 py-2 font-bold shadow-md">
                  SIGN UP
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {showSubscribeModal && (
      <div
        className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/60 backdrop-blur-sm"
        onClick={() => setShowSubscribeModal(false)}
      >
        <div
          className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="h-12 bg-brand" />

          <button
            type="button"
            aria-label="Close"
            onClick={() => setShowSubscribeModal(false)}
            className="absolute top-3 right-3 text-gray-500 hover:text-black transition-colors"
          >
            <X className="w-6 h-6" />
          </button>

          <div className="px-6 sm:px-10 pt-8 pb-10">
            <div className="flex justify-center mb-4">
              <div className="w-12 h-12 rounded-full bg-brand/20 flex items-center justify-center">
                <Mail className="w-6 h-6 text-brand" />
              </div>
            </div>

            <h3 className="text-center text-2xl sm:text-3xl font-modum font-bold tracking-wide text-gray-900 mb-8">
              Join our mailing list for <br className="hidden sm:block" /> latest updates!
            </h3>

            <form
              onSubmit={handleSubscribeSubmit}
              className="flex flex-col md:flex-row items-stretch gap-3"
            >
              <input
                type="text"
                name="firstName"
                placeholder="First Name*"
                value={subscribeForm.firstName}
                onChange={handleSubscribeChange}
                required
                className="flex-1 bg-gray-100 text-gray-700 placeholder-gray-400 px-4 py-3 rounded-md outline-none focus:ring-2 focus:ring-brand"
              />
              <input
                type="email"
                name="email"
                placeholder="Email Address*"
                value={subscribeForm.email}
                onChange={handleSubscribeChange}
                required
                className="flex-1 bg-gray-100 text-gray-700 placeholder-gray-400 px-4 py-3 rounded-md outline-none focus:ring-2 focus:ring-brand"
              />
              <button
                type="submit"
                disabled={subscribing}
                className="bg-gray-800 text-white font-semibold px-6 py-3 rounded-md hover:bg-black transition-all duration-200 disabled:opacity-50"
              >
                {subscribing ? "Subscribing..." : "Subscribe!"}
              </button>
            </form>
          </div>
        </div>
      </div>
    )}

    </div>


  );
}
